module.exports = __webpack_public_path__ + "34736292/img/ion_calendar-number.3ac5bd07.svg";